// File for logic corresponding to the WP Navigation block component (Election Navigation MVP - WC 1637)
import './election-navigation.scss';
